<div class="container">
  <div class="aligncenter tagline">
    <h1>Find a health professional that suits your needs</h1>
    <h2> This is for information only and doesn’t confirm coverage under your policy. </h2>
  </div>
  <div class="two-columns tab-headers">
    <div class="col1of2">
      <div class="ap-providers-header selected" (click)="switchAPxEC('ap')">
        <div class="ap-providers"></div>
        <h2>Affiliated Providers</h2>
      </div>
    </div>
    <div class="col2of2">
      <div class="ec-providers-header" (click)="switchAPxEC('ec')">
        <div class="ec-providers"></div>
        <h2>Easy-Claim partners</h2>
      </div>
    </div>
  </div>
  <div class="two-columns">
    <div class="col1of2">
      <ul class="ap-providers-content">
        <li>
          Affiliated Providers are doctors, specialists or medical facilities contracted to provide Southern Cross
          members with certain healthcare services at agreed prices.
        </li>
        <li>
          Some healthcare services are
          <a
            target="_blank"
            href="https://www.southerncross.co.nz/society/for-members/Making-a-claim/Affiliated-Provider/Affiliated-Provider-only-healthcare-services"
            >'Affiliated Provider-only'</a
          >, which means they're only covered by your policy if performed by an Affiliated Provider.
        </li>
      </ul>
    </div>
    <div class="col2of2">
      <ul class="ec-providers-content hidden-content">
        <li>
          <a target="_blank" href="https://www.southerncross.co.nz/society/for-members/Making-a-claim/easy-claim"
            >Easy-Claim partners</a
          >
          provide a convenient way for Southern Cross members to claim for eligible day-to-day healthcare services at
          the time of purchase.
        </li>
        <li>
          Just show your Member card (it's on the app) or mention your number and they’ll do the rest. If your plan
          covers the product or service, we'll reimburse the provider directly and you'll only pay any remaining
          contribution you're responsible for.
        </li>
      </ul>
    </div>
  </div>
</div>
